export default [
  {
    path: '/',
    redirect: 'login'
  }, {
    path: '/login',
    name: 'login',
    component: () => import('../../views/login/index.vue')
  }, {
    path: '/index',
    name: 'index',
    component: () => import('../../views/index/index.vue'),
    children: [
      { // 配送记录
        path: '',
        name: '配送记录',
        component: () => import('../../views/deliveryRecord/index.vue'),
        details: {
          title: 'deliveryRecord',
          icon: 'icon-peisongjilu',
          permissionId: '1'
        }
      }, { // 退料记录
        path: 'storesReturnedRecord',
        name: '退料记录',
        component: () => import('../../views/storesReturnedRecord/index.vue'),
        details: {
          title: 'storesReturnedRecord',
          icon: 'icon-jilu',
          permissionId: '2'
        }
      }, { // 设备管理
        path: 'deviceManage',
        name: '设备管理',
        component: () => import('../../views/deviceManage/index.vue'),
        details: {
          title: 'deviceManage',
          icon: 'icon-09_shebeiguanli',
          permissionId: '3'
        }
      }, { // 柜门管理
        path: 'doorManage',
        name: '柜门管理',
        component: () => import('../../views/doorManage/index.vue'),
        details: {
          hidden: true,
          title: 'doorManage',
          icon: 'icon-iconset0499',
          permissionId: '4'
        }
      }, { // 开箱日志
        path: 'unpackLog',
        name: '开箱日志',
        component: () => import('../../views/unpackLog/index.vue'),
        details: {
          hidden: true,
          title: 'unpackLog',
          icon: 'icon-box2xiangzi',
          permissionId: '5'
        }
      }, { // 信息发送日志
        path: 'shortMessageLog',
        name: '信息发送日志',
        component: () => import('../../views/shortMessageLog/index.vue'),
        details: {
          title: 'shortMessageLog',
          icon: 'icon-duanxinfasong',
          permissionId: '6'
        }
      }, { // 角色管理
        path: 'roleManage',
        name: '角色管理',
        component: () => import('../../views/roleManage/index.vue'),
        details: {
          title: 'roleManage',
          icon: 'icon-jiaoseguanli',
          permissionId: '7'
        }
      }, { // 系统用户管理
        path: 'backstageManage',
        name: '系统用户管理',
        component: () => import('../../views/backstageManage/index.vue'),
        details: {
          title: 'backstageManage',
          icon: 'icon-kuaidiyuan',
          permissionId: '8'
        }
      }, { // 客户端版本管理
        path: 'clientVersionManagement',
        name: '客户端版本管理',
        component: () => import('../../views/clientVersionManagement/index.vue'),
        details: {
          title: 'clientVersionManagement',
          icon: 'icon-banbenguanli1',
          permissionId: '10'
        }
      }, { // 系统配置
        path: 'systemLayout',
        name: '系统配置',
        component: () => import('../../views/systemLayout/index.vue'),
        details: {
          title: 'systemLayout',
          icon: 'icon-xitongguanli1',
          permissionId: '9'
        }
      }
    ]
  }
]
